import React, { forwardRef } from 'react';
import { HStack as ChakraHStack, StackProps } from '@chakra-ui/react';
interface Props extends StackProps {
  children?: React.ReactNode;
}
export const HStack = forwardRef<HTMLDivElement, Props>(
  (props, ref): JSX.Element => {
    return (
      <ChakraHStack {...props} ref={ref}>
        {props.children}
      </ChakraHStack>
    );
  }
);
